import { useQuery } from "@tanstack/react-query";
import type { Province } from "@/lib/types";
import { API_BASE_URL } from "@/lib/api/config";

const fetchProvinces = async (): Promise<Province[]> => {
  const response = await fetch(`${API_BASE_URL}/api/locations/provinces`);
  if (!response.ok) {
    throw new Error("Failed to fetch provinces");
  }
  const data = await response.json();
  return data.data.provinces; // Adjust based on your actual API response structure
};

export const useProvinces = () => {
  return useQuery<Province[], Error>({
    queryKey: ["provinces"],
    queryFn: fetchProvinces,
    staleTime: Infinity, // Lookup data is generally static
    gcTime: Infinity,
  });
};
